import { LitElement, html, Splide } from '@hh/global.js'

class LandingPagePromoSlider extends LitElement {
  static properties = {
    slider: { state: true },
  }

  connectedCallback() {
    super.connectedCallback()

    const slider = this.querySelector('.splide')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'slide',
      fixedWidth: '60%',
      arrows: false,
      gap: 10,
      drag: 'free',
      snap: false,
      easing: 'ease',
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('landing-page-promo-slider', LandingPagePromoSlider)
